import { Button } from 'antd';
import classNames from 'classnames';
import { ForwardedRef, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { DISHWASHER_OPTIONS } from '@common/enums';

export interface DishwasherOptionsProps {
    dishwasherSelectedOption?: DISHWASHER_OPTIONS;
    onOptionSelect: (option: DISHWASHER_OPTIONS) => void;
}

const DishwasherOptions = (
    { dishwasherSelectedOption, onOptionSelect }: DishwasherOptionsProps,
    ref: ForwardedRef<HTMLDivElement>
): JSX.Element => {
    const { t } = useTranslation();
    return (
        <div ref={ref} className="appliance-options">
            <Button
                className={classNames({ selected: dishwasherSelectedOption === DISHWASHER_OPTIONS.BROWSE_DISHWASHERS })}
                onClick={() => onOptionSelect(DISHWASHER_OPTIONS.BROWSE_DISHWASHERS)}
            >
                {t('SCROLLABLE_AREA.DISHWASHER.OPTIONS.BROWSE_DISHWASHERS')}
            </Button>

            <Button
                className={classNames('dishwasher-expansive-button', {
                    selected: dishwasherSelectedOption === DISHWASHER_OPTIONS.SUPPLY_DISHWASHERS,
                })}
                onClick={() => onOptionSelect(DISHWASHER_OPTIONS.SUPPLY_DISHWASHERS)}
            >
                {t('SCROLLABLE_AREA.DISHWASHER.OPTIONS.SUPPLY_DISHWASHERS')}
                {DISHWASHER_OPTIONS.SUPPLY_DISHWASHERS === dishwasherSelectedOption && (
                    <div className="dishwasher-button-subtitle">
                        <span>{t('SCROLLABLE_AREA.DISHWASHER.SUPPLY_DISHWASHER_INFO')}</span>
                    </div>
                )}
            </Button>

            <Button
                className={classNames({ selected: dishwasherSelectedOption === DISHWASHER_OPTIONS.NO_DISHWASHERS })}
                onClick={() => onOptionSelect(DISHWASHER_OPTIONS.NO_DISHWASHERS)}
            >
                {t('SCROLLABLE_AREA.DISHWASHER.OPTIONS.NO_DISHWASHERS')}
            </Button>
        </div>
    );
};

export default forwardRef<HTMLDivElement, DishwasherOptionsProps>(DishwasherOptions);
